<template>
    <div>
        <b-modal id="sap-payment-delete-modal" cancel-title="Abbrechen"
            ok-title="Alle Zahlungen löschen"
            size="xl" title="Zahlungen löschen"
            :visible="isModalOpen"
            @hidden="reset(); $emit('close')"
            @ok="deletePayments" @show="loadPayments">
            <div v-if="isLoading" class="d-flex justify-content-center pt-1">
                <csp-loading-indicator/>
            </div>
            <div v-else>
                <div v-if="payments.length > 0">
                    <h2 class="mb-4">
                        Zahlungen, die aus der selben SAP Zahlung erstellt wurden
                    </h2>
                </div>
                <b-card v-for="payment in payments" :key="payment.id" class="info-card">
                    <b-row>
                        <b-col v-for="(value, key) in filteredPaymentAttributes(payment)" :key="key" cols="4">
                            <div class="info-card-element">
                                <label>
                                    {{ labels[key] || key }}
                                </label>
                                <div class="value">
                                    {{ formatters[key] ? formatters[key](value) : value }}
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <hr>
                </b-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import '@desktop/scss/components/record/document-upload-modal.scss';
    import {formatDate} from '@js/functions/date';
    import {formatCurrencyCents} from '@js/functions/format';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'CostUnitPaymentDeletionModal',
        props: {
            paymentId: {
                type: Number,
                default: null,
            },
            costUnitId: {
                type: Number,
                default: null,
            },
            isModalOpen: {
                type: Boolean,
                default: false,
            },
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: ['close', 'updated', 'update:showModal'],
        data() {
            return {
                payments: [],
                isLoading: true,
                labels: {
                    costUnitPaymentId: 'ID',
                    costUnit: 'Bezeichnung',
                    costUnitReceipt: 'Beleg Nr.',
                    paymentType: 'Art der Zahlung',
                    datePaid: 'bezahlt am',
                    amountPaidNet: 'Eingegangen (netto)',
                    amountPaidGross: 'Eingegangen (brutto)',
                    amountVat: 'USt.-Betrag',
                    vatRate: 'USt.',
                    description: 'Bemerkung',
                    userName: 'Hinzugefügt von',
                },
                formatters: {
                    datePaid: formatDate,
                    amountPaidNet: formatCurrencyCents,
                    amountPaidGross: formatCurrencyCents,
                    amountVat: formatCurrencyCents,
                    vatRate: (value) => `${value}%`,
                },
            };
        },
        computed: {
            show: {
                get() {
                    return this.isModalOpen;
                },
                set(value) {
                    this.$emit('update:showModal', value);
                },
            },
        },
        methods: {
            filteredPaymentAttributes(payment) {
                const attributes = {...payment.attributes};

                if (attributes.paymentAdvice === null) {
                    delete attributes.paymentAdvice;
                }
                if (attributes.source === null) {
                    delete attributes.source;
                }

                return attributes;
            },
            deletePayments(event) {
                event.preventDefault();
                this.isLoading = true;
                recordRepository.deleteCostUnitPaymentsForSapPayment(this.recordId, this.costUnitId, this.paymentId)
                    .then(() => {
                        flashMessenger.addSuccess('Zahlungen erfolgreich gelöscht.');
                        this.$nextTick(() => {
                            this.$emit('updated');
                            this.$emit('close');
                        });
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            },
            loadPayments() {
                this.isLoading = true;
                recordRepository.loadCostUnitPaymentsForSapPayment(this.recordId, this.costUnitId, this.paymentId).then(
                    (response) => {
                        this.payments = response.data;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
            reset() {
                this.isLoading = true;
                this.payments = [];
            },
        },
    }
</script>
